var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      attrs: { page: "/explore", pageTitle: "Explore", tabs: true },
      scopedSlots: _vm._u([
        {
          key: "tabs",
          fn: function () {
            return [
              _c(
                "v-tabs",
                {
                  staticClass: "white--text",
                  attrs: { "background-color": "transparent" },
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c("v-tabs-slider", { attrs: { color: "white" } }),
                  _vm._v(" "),
                  _c("v-tab", { staticClass: "white--text" }, [
                    _vm._v("Categories"),
                  ]),
                  _vm._v(" "),
                  _c("v-tab", { staticClass: "white--text" }, [
                    _vm._v("All Events"),
                  ]),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          staticStyle: { "background-color": "transparent" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            "v-tab-item",
            { staticClass: "h-full", attrs: { value: 0 } },
            [
              _c("ExploreCategories", {
                attrs: {
                  successMessage: _vm.successMessage,
                  errors: _vm.errors,
                },
                on: {
                  selectClass: function ($event) {
                    _vm.selectedClass = $event
                  },
                  createLesson: function ($event) {
                    _vm.bookingForm = true
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { staticClass: "h-full", attrs: { value: 1 } },
            [
              _c("ExploreAllEvents", {
                attrs: {
                  calendarMin: _vm.calendarMin,
                  calendarMax: _vm.calendarMax,
                },
                on: {
                  selectClass: function ($event) {
                    _vm.selectedClass = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.selectedClass
        ? _c("SoliForm", {
            attrs: {
              hideBtn: "",
              title: `Register for ${_vm.selectedClass.title}`,
              textSubtitle: "Online registration coming soon",
            },
            on: {
              reset: function ($event) {
                _vm.selectedClass = null
              },
              submit: _vm.confirmRegistration,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("v-container", { staticClass: "pt-0" }, [
                        _c("div", { staticClass: "soli-grey" }, [
                          _vm._v(
                            "\n                    Please contact\n                    "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: `mailto:${_vm.selectedClass.location.email}`,
                              },
                            },
                            [_vm._v(_vm._s(_vm.selectedClass.location.email))]
                          ),
                          _vm._v(
                            "\n                    to get started\n                "
                          ),
                        ]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2054707112
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.bookingForm
        ? _c("CreateLesson", {
            attrs: {
              errors: _vm.errors,
              bookingSource: { isSelfServe: true },
              relationships: _vm.relationships,
            },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.bookingForm = null))
              },
              success: _vm.handleSuccess,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }